import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import "./termini-e-condizioni.css";


const AboutPage = () => (
  <>
    <SEO title="About" keywords={[`Termini e condizioni`]} />
    <div className="termsConditions">
    <h2>Termini e Condizioni</h2>

<p>Data di entrata in vigore: 9 aprile 2019</p>

<p>Si prega di leggere attentamente i presenti "Termini e Condizioni" prima di utilizzare il sito web http://www.crearemondi.it/ gestito da CreareMondi.it ("noi" o "nostro").</p>

<p>L'accesso e l'utilizzo del servizio sono subordinati all'accettazione e al rispetto dei presenti "Termini e Condizioni". I presenti "Termini e Condizioni" si applicano a tutti i visitatori, utenti e altri che accedono a http://www.crearemondi.it/ o lo utilizzano.</p>

<p>Accedendo o utilizzando http://www.crearemondi.it/ accetti di essere vincolato da questi "Termini e Condizioni". Se non sei d'accordo con qualsiasi parte di questi "Termini e Condizioni", non puoi accedere al servizio.</p>

<h2>Collegamenti ad altri siti web</h2>

<p>Il nostro Servizio potrebbe contenere collegamenti a siti web e servizi di terzi o che non sono di proprietà o controllati da CreareMondi.it.</p>

<p>CreareMondi.it non ha alcun controllo né si assume alcuna responsabilità per il contenuto, le politiche sulla privacy o le pratiche di siti web o servizi di terzi. L'utente riconosce e accetta inoltre che CreareMondi.it non sarà responsabile, direttamente o indirettamente, per qualsiasi danno o perdita causati o presunti essere causati da o in relazione all'uso o affidamento su tali contenuti, beni o servizi disponibili su o tramite tali siti web o servizi.</p>

<p>Ti consigliamo vivamente di leggere i "Termini e Condizioni" e le politiche sulla privacy di qualsiasi sito web o servizio di terze parti che visiti.</p>

<h2>Proprietà dei contenuti</h2>

<p>Tutti i marchi, nomi di prodotti, nomi commerciali, nomi corporativi e società eventualmente citati o riprodotti nel sito appartengono ai rispettivi proprietari che ne detengono integralmente i diritti. L'uso di immagini caratteristiche o peculiari e logotipi non implica in alcun modo l'appartenenza di questo sito alle persone fisiche o giuridiche eventualmente connessevi, né un coinvolgimento delle stesse - diretto o indiretto - con le attività e le finalità proprie di questo sito e viceversa.</p>

<p>Le immagini (foto, grafica, layout) presenti in questo sito web sono utilizzate solo a scopo illustrativo e appartengono ai rispettivi proprietari che ne detengono integralmente i diritti.</p>

<p>I testi non firmati, salvo diversa indicazione, si intendono di proprietà dell'autore/titolare del sito e non potranno essere pubblicati, riscritti, commercializzati, distribuiti salvo preventiva autorizzazione da parte del proprietario del sito.</p>

<h2>Cookie Policy</h2>

<p>Questo sito o gli strumenti di terze parti in esso integrati fanno uso di cookie necessari per il funzionamento e per il raggiungimento delle finalità descritte nella cookie policy. Per saperne di più o per revocare il consenso relativamente a uno o tutti i cookie, fai riferimento alla cookie policy al link <a href="https://www.iubenda.com/privacy-policy/36901609" target="_blank" rel="noopener noreferrer">https://www.iubenda.com/privacy-policy/36901609</a>.
Utilizzando http://www.crearemondi.it/ dichiari di accettare l’utilizzo di cookie.</p>

<h2>Normativa vigente</h2>

<p>I presenti "Termini e Condizioni" saranno regolati e interpretati in conformità con le leggi italiane.</p>

<p>La mancata considerazione di qualsiasi diritto o disposizione nei presenti "Termini e Condizioni" non sarà considerata una rinuncia a tali diritti o disposizioni. Se una qualsiasi disposizione di questi "Termini e Condizioni" è ritenuta non valida o non applicabile da un tribunale, le restanti disposizioni di questi rimarranno in vigore.</p>


<h2>Modifiche ai presenti "Termini e Condizioni"</h2>

<p>Il titolare del sito web si riserva il diritto, a sua esclusiva discrezione, di modificare o sostituire i presenti "Termini e Condizioni" in qualsiasi momento. In caso di revisione, fornirà un preavviso di almeno 30 giorni prima che i nuovi "Termini e Condizioni" entrino in vigore.</p>

<p>Continuando ad accedere o utilizzare il nostro servizio dopo l'entrata in vigore di tali revisioni, l'utente accetta di essere vincolato dai Termini e Condizioni modificati. Se non si accettano i nuovi Termini e Condizioni, si prega di interrompere l'uso del servizio.</p>

<h2>Contatti</h2>
<p>In caso di domande sui presenti "Termini e Condizioni", si prega di contattarci tramite e-mail all'indirizzo <a href="mailto: info@crearemondi.it">info@crearemondi.it</a></p>

</div>
    </>
)

export default AboutPage
